import "./Process.css";

import {
  FaClipboardList,
  FaLightbulb,
  FaPalette,
  FaCode,
  FaBug,
  FaRocket,
  FaHeadset
} from "react-icons/fa";

const steps = [
  {
    icon: <FaClipboardList />,
    title: "Requirement Analysis",
    desc: "We understand your business goals, target audience and project requirements."
  },
  {
    icon: <FaLightbulb />,
    title: "Planning",
    desc: "Project architecture, technology selection and development roadmap."
  },
  {
    icon: <FaPalette />,
    title: "UI / UX Design",
    desc: "Modern, responsive and user-friendly interface design."
  },
  {
    icon: <FaCode />,
    title: "Development",
    desc: "Clean, secure and scalable coding using modern technologies."
  },
  {
    icon: <FaBug />,
    title: "Testing",
    desc: "Complete testing for performance, security and compatibility."
  },
  {
    icon: <FaRocket />,
    title: "Deployment",
    desc: "Deploy your project on secure cloud hosting with optimization."
  },
  {
    icon: <FaHeadset />,
    title: "Support & Maintenance",
    desc: "Continuous updates, monitoring and technical support."
  }
];

function Process() {
  return (
    <section className="process" id="process">

      <div className="container">

        <div className="section-title">

          <h2>Our Development Process</h2>

          <p>
            We follow a proven development process to deliver reliable,
            scalable and high-quality digital solutions.
          </p>

        </div>

        <div className="timeline">

          {steps.map((step, index) => (

            <div className="timeline-item" key={index}>

              <div className="timeline-number">
                {index + 1}
              </div>

              <div className="timeline-icon">
                {step.icon}
              </div>

              <div className="timeline-content">

                <h3>{step.title}</h3>

                <p>{step.desc}</p>

              </div>

            </div>

          ))}

        </div>

      </div>

    </section>
  );
}

export default Process;